import styled from "styled-components";

const WhyProfiles = () => {
  return (
    <StyledWhyProfiles className="">
      <div className="section_wrapper home_parent_wrapper">
        <h3>
          Why choose <span>Profiles</span>?
        </h3>
        <div className="why_profiles">
          <div className="why_profiles_card">
            <div className="why_profiles_img">
              <img
                width={48}
                height={48}
                src="/images/search.gif"
                alt="Reduce your time-to-hire by 50%"
              />
            </div>
            <h5>Reduce your time-to-hire by 50%</h5>
            <p>
              Save time and effort finding skilled candidates! Our advanced
              filters make it easy to select from a pool of pre-screened talent
              with specific skills, freeing up valuable hours for more important
              work.
            </p>
          </div>
          <div className="why_profiles_card">
            <div className="why_profiles_img">
              <img
                width={48}
                height={48}
                src="/images/user.gif"
                alt="Eliminate frustrating hiring processes"
              />
            </div>
            <h5>Eliminate frustrating hiring processes</h5>
            <p>
              Stay ahead of talent shortages, access smart talent quickly, and
              skip lengthy hiring processes.
            </p>
          </div>
          <div className="why_profiles_card">
            <div className="why_profiles_img">
              <img
                width={48}
                height={48}
                src="/images/trend_up.gif"
                alt="Experience candidates' personality"
              />
            </div>
            <h5>Experience candidates' personality</h5>
            <p>
              Profiles offers a unique way to learn about engineers beyond their
              resume. You get an immersive look at their personality to see if
              they're a good fit for your team.
            </p>
          </div>
          <div className="why_profiles_card">
            <div className="why_profiles_img">
              <img
                width={48}
                height={48}
                src="/images/bolt.gif"
                alt="Zero risk"
              />
            </div>
            <h5>Zero risk</h5>
            <p>
              We offer a two-week trial period for each engineer. If you opt to
              cancel within the initial two weeks, there will be no charges.
            </p>
          </div>
        </div>
      </div>
    </StyledWhyProfiles>
  );
};

const StyledWhyProfiles = styled.div`
  margin: 8rem 0;
  .section_wrapper {
    padding: 8rem 0;
  }

  h3 {
    font-size: 48px;
    font-weight: 700;
    margin-bottom: 8rem;
    text-align: center;
  }

  h3 span {
    color: #34a853;
  }

  .why_profiles {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 3.4rem;
  }

  .why_profiles_img {
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(
      180deg,
      rgba(52, 168, 83, 0.6) 0%,
      rgba(184, 211, 68, 0.6) 100%
    );
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }

  .why_profiles img {
    width: 4.8rem;
    height: 4.8rem;
  }

  .why_profiles_card h5 {
    margin: 3.4rem 0 2.4rem 0;
    font-size: 24px;
    font-weight: 700;
  }

  @media screen and (max-width: 750px) {
    margin: 4rem 0;
    .section_wrapper {
      padding: 4rem 0;
    }

    h3 {
      font-size: 32px;
      margin-bottom: 3.2rem;
      text-align: left;
    }

    .why_profiles {
      display: grid;
      grid-template-columns: 1fr;
      gap: 3.4rem;
    }

    .why_profiles_card h5 {
      margin: 1.6rem 0 1.2rem 0;
      font-size: 16px;
    }

    .why_profiles_img {
      width: 52px;
      height: 52px;
    }

    .why_profiles img {
      width: 2rem;
      height: 2rem;
    }
  }
`;

export default WhyProfiles;
